import { useCallback } from "react";
import { createZitadelUser, getCurrentUser, activateZitadelUser, } from "../api/user.js";
export const useUser = () => {
    const createUser = useCallback(async (data) => {
        const { firstName, lastName, email, password, marketingConsent = false, address, additionalAddress, postalCode, city, countryCode, locale, additionalInfo = { travelers: [] }, } = data;
        const transformedTravelers = additionalInfo.travelers.map((traveler) => ({
            first_name: traveler.firstName,
            last_name: traveler.lastName,
            gender: traveler.gender,
            date_of_birth: traveler.dateOfBirth,
            passenger_type: traveler.passengerType,
            address: traveler.address,
            additional_address: traveler.additionalAddress,
            postal_code: traveler.postalCode,
            city: traveler.city,
            country_code: traveler.countryCode,
            account_owner: traveler.accountOwner,
        }));
        const userResponse = await createZitadelUser({
            first_name: firstName,
            last_name: lastName,
            email,
            password,
            marketing_consent: marketingConsent,
            address,
            additional_address: additionalAddress,
            postal_code: postalCode,
            city,
            country_code: countryCode,
            locale,
            additional_info: {
                travelers: transformedTravelers,
            },
        });
        return userResponse;
    }, [createZitadelUser]);
    const activateUser = async (userId, activationCode) => {
        return await activateZitadelUser(userId, {
            activation_code: activationCode,
        });
    };
    const getUser = async () => {
        return await getCurrentUser();
    };
    return { createUser, activateUser, getUser };
};
